// `P0-DLW-003`, and the founder's rule of full design fidelity. The console's
// entry has imported this on its first line since `P0-UIK-021`; dealer-web's
// never did, so every Tailwind class in the shell and in the shared invitation
// screen resolved to nothing and the kit's controls fell back to the browser's
// own. The first whole walk was taken on that page.
import "@hakili/ui/styles.css";
import "@hakili/ui/veilleur.css";
import "./dealer-colours.css";

import { createRoot } from "react-dom/client";

import { App } from "./App.js";

/**
 * The entry point of `dealer-web`, `P0-UIK-020`.
 *
 * **What this file does, and what it deliberately does not.** It finds the
 * mount point and opens a React root on it. That is the whole of it, and the
 * restraint is the point rather than an omission.
 *
 * This item's scope is *"a bundler, an entry point and a `build` script per
 * app"* , the machinery that turns a component tree into something a static
 * host can serve. It is NOT the wiring of le concessionnaire's screens. `this application's shell, when it is built`
 * takes required props, and inventing values for them here would be writing
 * product inside an infrastructure item: a router, a session gate and a role
 * whitelist would all have to be guessed, and each is owned by a screen item
 * that names its own workflow ids.
 *
 * So the shells stay where they are, compiled by `typecheck` and exercised by
 * their own specs, and this entry mounted an empty root. When the screens'
 * items land they replace this body , not this file's existence.
 *
 * **They landed in round B of dealer onboarding.** The body below is the
 * replacement that sentence promised, and the file's existence is unchanged ,
 * which is exactly what the original header said would happen.
 */
const racine = document.querySelector("#racine");
if (racine === null) {
  // Not a silent no-op: a missing mount point means the entry document and the
  // entry script disagree, and the page would be blank with nothing in the
  // console to say why.
  throw new Error("racine introuvable");
}

/**
 * The API origin, substituted as a literal at build time.
 *
 * `packages/config/vite` refuses a build with no `VITE_API_ORIGIN`, and passing
 * it DOWN rather than reading it inside the application is what lets a spec
 * render `App` against a stub and never touch a document.
 */
createRoot(racine).render(<App origin={import.meta.env.VITE_API_ORIGIN} />);
